@if (is_create()) {
  <p class="acta-tab-hint">Guarda el acta para añadir tus notas personales.</p>
} @else {
  <p class="acta-tab-hint acta-tab-hint-info">Solo tú puedes ver y editar estas notas. Se guardan automáticamente.</p>

  <div class="editor-container">
    <editor
      [formControl]="personal_notes_control()"
      [apiKey]="tiny_mce_api_key()"
      cloudChannel="6"
      id="personal_notes_html"
      [init]="tiny_mce_init()"
      initialValue=""
      [inline]="false"
      tagName="div"
    ></editor>
  </div>
}
